<template>
  <section class="layout-container" :id="info.id">
    <!-- 编辑模式 -->
    <template v-if="isEditMode">
      <section v-if="!info.code" class="w wrapper" v-html="info.code"></section>
      <section class="w" v-else v-html="info.code"></section>
    </template>
    <!-- 渲染模式 -->
    <template v-else>
      <section v-html="info.code"></section>
    </template>
  </section>
</template>
<script>
export default {
  /******************************************
  ** HTML组件
  * @description HTML组件
  * @author stone
  *****************************************
  info            Object             属性样式数据
  isEditMode      Boolean            是否编辑模式
  *****************************************/
  name: 'htmlLayout',
  components: {},
  props: {
    info: {
      type: Object
    },
    isEditMode: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
.layout-container {
  .w {
    cursor: move;
  }
  .wrapper {
    border: 1px solid transparent;
    min-height: 200px;
    display: flex;
    justify-content: center;
    background: #f1f5f8;
    align-items: center;

    &:after {
      content: 'HTML片段';
      font-size: 14px;
      color: #9ba5b2;
    }
    .info {
      font-size: 14px;
      color: #9ba5b2;
    }
  }
}
</style>
